import { render, staticRenderFns } from "./PopupTitle.vue?vue&type=template&id=60fe42f6&scoped=true"
import script from "./PopupTitle.vue?vue&type=script&lang=js"
export * from "./PopupTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fe42f6",
  null
  
)

export default component.exports